import { render, staticRenderFns } from "./ProductAgoraDocumentationSideBar.vue?vue&type=template&id=70de2a76&scoped=true&"
import script from "./ProductAgoraDocumentationSideBar.vue?vue&type=script&lang=js&"
export * from "./ProductAgoraDocumentationSideBar.vue?vue&type=script&lang=js&"
import style0 from "./ProductAgoraDocumentationSideBar.vue?vue&type=style&index=0&id=70de2a76&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70de2a76",
  null
  
)

export default component.exports